/*  ==========================================================================
    MAGNIFIC POPUP
    Helper functions to create a lightbox for images, videos or iframes.

    INFO:
    - needs "magnific-popup"
    - 3 different types are prepared:
        1. single
        2. gallery
        3. iframe
    - rough example:

    <div class="mfp--gallery">
        <a class="mfp__item" href="/image.jpg" title="Example"></a>
    </div>
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import 'magnific-popup';

// local imports
import * as vars from '../../globals/variables';

/*
 * SINGLE
 */

export function initSingleImage ($element) {
    $element.find('.mfp--single').each(function(){
        $(this).magnificPopup({
            delegate: 'a.mfp__item:not(.hidden)',
            type: 'image'
        });
    });
}

/*
 * GALLERY
 */

export function initGallery ($element) {
    $element.find('.mfp--gallery').each(function(){
        $(this).magnificPopup({
            delegate: 'a.mfp__item:not(.hidden)',
            gallery: {
                enabled: true
            },
            type: 'image'
        });
    });
}

/*
 * IFRAME
 */

export function initIframe ($element) {
    $element.find('.mfp--iframe').each(function(){
        $(this).magnificPopup({
            delegate: 'a.mfp__item:not(.hidden)',
            type: 'iframe'
        });
    });
}


// WEBPACK FOOTER //
// ./source/js/utilities/lib/magnific-popup.js